import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { Icon, Spin } from 'antd';

function Loading() {
  const style = {
    textAlign: 'center',
    paddingTop: '80px',
  }

  return (
    <div style={style}>
      <Spin size="large" indicator={<Icon type="loading" spin />} />
    </div>
  )
}


export default Loading;